import { EmailService } from '@app/core/email/services/email.service';

export const SERVICES = [
  EmailService
];
